<template>
  <div class="archived-label-cont">
    <div :class="{ 'archived-label': !disabled }"><slot></slot></div>
    <div
      v-if="!disabled && !hideArchivedText"
      class="ml-1 archived-label-archived"
    >
      (Archived)
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hideArchivedText: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.archived-label-cont {
  display: flex;
  align-items: center;
  .archived-label {
    text-decoration: line-through;
    font-style: italic;
  }
  .archived-label-archived {
    color: var(--rufous);
    font-style: italic;
    font-weight: bold;
  }
}
</style>
